import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight, Building2, Compass, Factory, FileSignature, Hammer, Home as HomeIcon,
  MessageCircle, Package, Sofa,
} from "lucide-react";
import { Reveal } from "../components/Reveal";
import { COMPANY, SERVICES } from "../lib/constants";

const ICONS = { Hammer, Package, Home: HomeIcon, Building2, Sofa, Factory, FileSignature, Compass };

export default function Services() {
  return (
    <main data-testid="services-page">
      <section className="bg-[var(--m-bg-2)] section-pad pt-32 md:pt-44">
        <div className="container-x">
          <span className="eyebrow">Services</span>
          <div className="gold-divider mt-4" />
          <h1 className="font-display text-5xl md:text-7xl mt-6 leading-[1] tracking-tight max-w-4xl">
            A complete <em className="italic text-[var(--m-teal)]">construction stack</em> under one engineer.
          </h1>
          <p className="mt-8 text-[var(--m-ink-2)] text-lg max-w-2xl leading-relaxed">
            From your first sketch to handover keys, Agartha handles drawings, approvals, structural
            execution, interiors, PEB and turnkey delivery — without sub-contracting away accountability.
          </p>
        </div>
      </section>

      <section className="section-pad" data-testid="services-list">
        <div className="container-x flex flex-col gap-px bg-[var(--m-border)]">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            const reverse = i % 2 === 1;
            return (
              <Reveal key={s.key} delay={i * 60}>
                <div
                  className={`grid grid-cols-1 lg:grid-cols-12 gap-0 bg-[var(--m-bg)] ${reverse ? "lg:[direction:rtl]" : ""}`}
                  data-testid={`services-row-${s.key}`}
                >
                  <div className="lg:col-span-5 [direction:ltr]">
                    <img src={s.image} alt={s.title} className="w-full h-72 lg:h-full object-cover" />
                  </div>
                  <div className="lg:col-span-7 p-10 md:p-14 flex flex-col justify-center [direction:ltr]">
                    <div className="flex items-center gap-4">
                      <span className="font-display italic text-[var(--m-gold)] text-3xl">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <Icon size={26} className="text-[var(--m-teal)]" strokeWidth={1.4} />
                    </div>
                    <h2 className="font-display text-3xl md:text-4xl mt-4 leading-tight">{s.title}</h2>
                    <p className="mt-5 text-[var(--m-ink-2)] leading-relaxed max-w-xl">{s.desc}</p>
                    <div className="mt-8 flex gap-3 flex-wrap">
                      <Link to="/quotation" className="btn-primary" data-testid={`service-cta-quote-${s.key}`}>
                        Inquire <ArrowRight size={14} />
                      </Link>
                      <a
                        href={`https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(`Hi, I'm interested in your ${s.title} service.`)}`}
                        target="_blank" rel="noopener noreferrer"
                        className="btn-secondary"
                        data-testid={`service-cta-wa-${s.key}`}
                      >
                        <MessageCircle size={14} /> WhatsApp
                      </a>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="bg-[var(--m-teal)] text-white" data-testid="services-bottom">
        <div className="container-x py-20 grid md:grid-cols-2 gap-10 items-center">
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05]">
            Don't see your project type? <em className="italic text-[var(--m-gold)]">Let's discuss.</em>
          </h2>
          <div className="flex gap-4 md:justify-end flex-wrap">
            <Link to="/quotation" className="btn-gold">Get Free Quote</Link>
            <Link to="/contact" className="btn-secondary" style={{ color: "#FDFBF7", borderColor: "#FDFBF7" }}>Contact Us</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
